module.exports = __webpack_public_path__ + "static/media/994386.a50066f4.png";